import { UserManageable } from "./types";

export const LANGUAGE_ACTION = "language";
export const LOGIN_ACTION = "login";
export const LOGOUT_ACTION = "logout";
export const STORE_CURRENT_USER_ACTION = "store_user";

interface LanguageAction {
  type: typeof LANGUAGE_ACTION;
  payload: string;
}

interface LoginAction {
  type: typeof LOGIN_ACTION;
  payload: {
    token: string;
  };
}

interface LogoutAction {
  type: typeof LOGOUT_ACTION;
}

interface StoreCurrentUserAction {
  type: typeof STORE_CURRENT_USER_ACTION;
  payload: UserManageable;
}

export type Action =
  | LanguageAction
  | LoginAction
  | LogoutAction
  | StoreCurrentUserAction;
